import React from 'react';

export default function About() {
  return (
    <div>
      <h1>About</h1>
      <p>
        PollWhere is an <a href="https://gitlab.com/huntertur/PollWhere">
        open source</a> project, licensed under the terms of the&nbsp;
        <a href="https://www.gnu.org/licenses/agpl-3.0.html">GNU Affero
        General Public License, version 3</a> or later.
      </p>
      <h2>License</h2>
      <p>
        Copyright &copy; 2022&nbsp;
        <a href="https://huntertur.net/">Hunter "Lilia Roo" Turcin</a>
      </p>
      <p>
        This program is free software: you can redistribute it and/or modify it
        under the terms of the GNU Affero General Public License as published
        by the Free Software Foundation, either version 3 of the License, or
        (at your option) any later version.
      </p>
      <p>
        This program is distributed in the hope that it will be useful, but
        WITHOUT ANY WARRANTY; without even the implied warranty of
        MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the GNU Affero
        General Public License for more details.
      </p>
      <p>
        You should have received a copy of the GNU Affero General Public
        License along with this program. If not, see&nbsp;
        <a href="https://www.gnu.org/licenses/">
          https://www.gnu.org/licenses/
        </a>.
      </p>
      <h2>Credits</h2>
      <p>
        PollWhere is not possible without the following software:
      </p>
      <ul>
        <li><a href="https://github.com/dotnet/aspnetcore">ASP.NET Core</a> (<a href="https://github.com/dotnet/efcore/blob/main/LICENSE.txt">MIT License</a>)</li>
        <li><a href="https://github.com/dotnet/efcore">Entity Framework Core</a> (<a href="https://github.com/dotnet/aspnetcore/blob/main/LICENSE.txt">MIT License</a>)</li>
        <li><a href="https://github.com/Leaflet/Leaflet">Leaflet</a> (<a href="https://github.com/Leaflet/Leaflet/blob/main/LICENSE">BSD 2-Clause License</a>)</li>
        <li><a href="https://github.com/facebook/react/">React</a> (<a href="https://github.com/facebook/react/blob/main/LICENSE">MIT License</a>)</li>
        <li><a href="https://sqlite.org/src/doc/trunk/README.md">SQLite</a> (<a href="https://www.sqlite.org/copyright.html">public domain</a>)</li>
      </ul>
    </div>
  )
}
